/**
 * 小数桁数のValidationチェック
 * decimals: 小数の桁数、0の場合はチェックしない
 */
export default {
  validate(
    value: string | undefined | null,
    { decimals = 0 }: { decimals: number }
  ): boolean {
    if (value === null || value === undefined || value === "") {
      return true;
    }
    const delimiterRegexPart = "\\.?";
    const decimalRegexPart = decimals === 0 ? "\\d*" : `(\\d{${decimals}})?`;
    const regex = new RegExp(
      `^-?\\d+${delimiterRegexPart}${decimalRegexPart}$`
    );

    return regex.test(String(value));
  },
};
